import React from "react";
import { GsdModuleNavItem } from "./GsdModuleNavItem.jsx";

/**
 * @param {object} props
 * @param {Array<{ id: string, label: string, items: object[] }>} props.groups
 * @param {(item: object, meta: object) => React.ReactNode} [props.renderLink]
 * @param {(item: object) => boolean} [props.isItemActive]
 * @param {string} [props.testId]
 */
export function GsdSidebarNav({ groups = [], renderLink, isItemActive, testId = "gsd-sidebar-nav" }) {
  return (
    <aside className="gsd-sidebar-nav" data-testid={testId}>
      {groups.map((group) => (
        <div key={group.id} className="gsd-sidebar-nav__group" data-testid={`gsd-nav-group-${group.id}`}>
          <span className="gsd-sidebar-nav__group-label">{group.label}</span>
          <nav className="gsd-sidebar-nav__items" aria-label={group.label}>
            {group.items.map((item) => (
              <GsdModuleNavItem
                key={item.id}
                item={item}
                isActive={isItemActive ? isItemActive(item) : false}
                renderLink={renderLink}
                className="gsd-sidebar-nav__item"
              />
            ))}
          </nav>
        </div>
      ))}
    </aside>
  );
}
